export const PlantItemRenewalContactDetailsPage = {
  changeEmailLabel: 'Do you want to change the contact email for these plant items?',
  changeEmailHelpMessage: 'We will use this email for ongoing communications, including renewal reminders.',
  newEmailLabel: 'Email addresss',
  newEmailHelpMessage: "You can enter a shared mailbox or someone else's email address.",
  phoneNumberLabel: 'Australian mobile or landline',
  phoneNumberHelpMessage: 'Include area code(s) for landline numbers.',
};
